export default {
    workflows: {
        title: "Workflows",
        description: "Manage custom workflows for AI agents",
        newWorkflow: "New Workflow",
        searchPlaceholder: "Search by name...",
        statusPlaceholder: "Filter by status",
        type: {
            default: "Default",
            custom: "Custom",
        },
        status: {
            active: "Active",
            inactive: "Inactive",
            draft: "Draft",
        },
        headers: {
            name: "Name",
            type: "Type",
            status: "Status",
            nodesCount: "Nodes",
            createdAt: "Created",
            actions: "Actions",
        },
        actions: {
            view: "View",
            edit: "Edit",
            delete: "Delete",
        },
        detail: {
            back: "Back",
            edit: "Edit",
            nodesCount: "Nodes",
            edgesCount: "Edges",
            createdAt: "Created At",
            visualization: "Workflow Visualization",
        },
        notFound: {
            title: "Workflow Not Found",
            message: "The requested workflow does not exist.",
            backToList: "Back to List",
        },
        noData: {
            title: "No Workflows",
            message: "Create your first workflow to get started.",
        },
        modal: {
            confirmDelete: "Delete Workflow",
            confirmDeleteMessage: "Are you sure you want to delete this workflow? This action cannot be undone.",
        },
        new: {
            title: "New Workflow",
        },
        edit: {
            title: "Edit Workflow",
        },
        editor: {
            addNode: "Add Node",
            deleteNode: "Delete Node",
            cancel: "Cancel",
            save: "Save",
            nodeProperties: "Node Properties",
            nodeType: "Type",
            nodeLabel: "Label",
            agentType: "Agent Type",
            actionType: "Action Type",
            condition: "Condition",
            nodeTypes: {
                start: "Start Node",
                agent: "Agent Node",
                decision: "Decision Node",
                action: "Action Node",
                end: "End Node",
            },
            defaultLabels: {
                start: "Start",
                agent: "Agent",
                decision: "Decision",
                action: "Action",
                end: "End",
            },
            agentTypes: {
                postino: "Postino/Mailer",
                classificatore: "Classifier",
                parser: "Parser",
                validatore: "Validator",
            },
            actionTypes: {
                notification_in_app: "In-App Notification",
                notification_email: "Email Notification",
                notification_both: "Complete Notification",
            },
            operators: {
                equals: "Equals",
                contains: "Contains",
                exists: "Exists",
                not_equals: "Not Equals",
                not_contains: "Not Contains",
            },
            savingWorkflow: "Saving workflow...",
            workflowSaved: "Workflow saved successfully!",
            relatedAccounts: "Related Accounts",
            searchAccounts: "Search accounts by name, email, or tax ID...",
            noAccountsFound: "No accounts found",
            taxId: "Tax ID",
            selectedCount: "{{count}} selected",
            close: "Close",
        },
        savingChanges: "Saving changes...",
        allSaved: "All saved!",
    },
};
